import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { ConfigStatus, Flow, Illustration, IntegrationType, Theme, Wordings } from '../../@types/config'

export const initialState = {
  flow: Flow.RLE,
  coopId: <string | undefined>undefined,
  theme: <Theme>{
    primary: '',
    primaryLight: '',
    secondary: '',
    secondaryLight: '',
    text: '',
    background: '',
  },
  tealium: true,
  illustration: Illustration.TEAL,
  isIframe: false,
  wordings: <Wordings>{
    contactForm: {
      headline: undefined,
      subline: undefined,
      bulletPointOne: undefined,
      bulletPointTwo: undefined,
      bulletPointThree: undefined,
    },
    realEstate: {
      headline: undefined,
      bulletPointOne: undefined,
      bulletPointTwo: undefined,
      bulletPointThree: undefined,
    },
  },
  status: ConfigStatus.PUBLISHED,
  integrationType: IntegrationType.IMMOBILIENSCOUT24,
  enableFrontendTracking: false,
}

const configSlice = createSlice({
  name: 'config',
  initialState: initialState,
  reducers: {
    updateFlow: (state, action: PayloadAction<Flow>) => {
      state.flow = action.payload
    },
    updateCoopId: (state, action: PayloadAction<string>) => {
      state.coopId = action.payload
    },
    updateThemePrimary: (state, action: PayloadAction<string>) => {
      state.theme.primary = action.payload
    },
    updateThemeSecondary: (state, action: PayloadAction<string>) => {
      state.theme.secondary = action.payload
    },
    updateThemeText: (state, action: PayloadAction<string>) => {
      state.theme.text = action.payload
    },
    updateThemeBackgroundColor: (state, action: PayloadAction<string>) => {
      state.theme.background = action.payload
    },
    updateTheme: (state, action: PayloadAction<Theme>) => {
      state.theme = action.payload
    },
    updateTealium: (state, action: PayloadAction<boolean>) => {
      state.tealium = action.payload
    },
    updateIframe: (state, action: PayloadAction<boolean>) => {
      state.isIframe = action.payload
    },
    updateIllustration: (state, action: PayloadAction<Illustration>) => {
      state.illustration = action.payload
    },
    updateWordings: (state, action: PayloadAction<Wordings>) => {
      state.wordings = action.payload
    },
    updateStatus: (state, action: PayloadAction<ConfigStatus>) => {
      state.status = action.payload
    },
    updateIntegrationType: (state, action: PayloadAction<IntegrationType>) => {
      state.integrationType = action.payload
    },
    updateEnableFrontendTracking: (state, action: PayloadAction<boolean>) => {
      state.enableFrontendTracking = action.payload
    },
  },
})

export const {
  updateFlow,
  updateCoopId,
  updateThemePrimary,
  updateThemeSecondary,
  updateThemeText,
  updateThemeBackgroundColor,
  updateTealium,
  updateIllustration,
  updateTheme,
  updateIframe,
  updateWordings,
  updateStatus,
  updateIntegrationType,
  updateEnableFrontendTracking,
} = configSlice.actions

export default configSlice.reducer
